export interface ISwitchAccount {
  employId: string
  token: string
}

export interface IMoengageUserAttribute {
  customerId: string
  firstName: string
  lastName: string
  userName: string
  email: string
  phone: string
  companyID: string
  countryCode: string
}

export interface IRequestInfoSignUp {
  dataInfo: any
  onSignUpError: (message: string) => void
  onSignUpSuccess: (object: object) => void
  xRecaptchaToken: string | null
}

export interface IRequestVerify {
  verificationCode: string
  callback: () => void
  xRecaptchaToken: string | null
}

export interface IRequestSignIn {
  info: {
    login: string
    password: string
    country_code: string
  }
  xRecaptchaToken: string | null
  cb: (object: object) => void
}

export interface IRequestAuth {
  accountId: number
  cb?: (data?: any) => void
}

export interface IRequestNewPwd {
  password: string
  currentPassword: string
  cb: VoidFunction
}

export interface IRequestSwitchAccount {
  id: string
  callback: VoidFunction
}

export interface CustomerFtlConfig {
  default_note: string
  allow_post_payment: boolean
  ltl_booking_end_time: string
  ltl_booking_start_time: string
  ltl_maximum_pickup_time_days: number
  hide_area_selector: boolean
  distance_calculator: string
  enable_sms_verification: boolean
  show_long_haul_time_type: boolean
  default_pickup_zoom: number
  default_center_lat_lng: string
  default_map_zoom: number
  default_address_component_pickup: any[]
  enable_parking_tolls_feature: boolean
  check_time_zone: boolean
  time_zone: string
  enable_cod_pod_new_rule: boolean
  cod_amount_limit_alert: number
  default_center_address: string
  max_number_of_location: number
  enable_customer_assign_driver: boolean
  maximum_mutiple_booking: number
  minimal_drivers_setting: number
  check_pod_by_default: boolean
  can_toggle_pod: boolean
  enable_batch_multiple: boolean
  enable_smart_load: boolean
}

export interface Login {
  accounts: Accounts
  access_token?: string
}

export interface Accounts {
  id: number
  address_detail: string
  name: string
  first_name?: string
  last_name?: string
  email?: string
  country_code?: string
  phone: string
  referral_code?: string
  avatar_square?: string
  business_name?: string
  sms_confirmed_at?: Date
  accounts?: Account[]
  link_admin?: string
  last_login_employ_id?: number
  currentCompanyId?: number
  must_update_password?: boolean
  account_type?: string
  default_note?: string
  allow_post_payment?: boolean
  ltl_booking_end_time?: string
  ltl_booking_start_time?: string
  ltl_maximum_pickup_time_days?: number
  hide_area_selector?: boolean
  distance_calculator?: string
  enable_sms_verification?: boolean
  show_long_haul_time_type?: boolean
  default_pickup_zoom?: number
  default_center_lat_lng?: string
  default_map_zoom?: number
  default_address_component_pickup?: any[]
  enable_parking_tolls_feature?: boolean
  check_time_zone?: boolean
  time_zone?: string
  enable_cod_pod_new_rule?: boolean
  cod_amount_limit_alert?: number
  default_center_address?: string
  max_number_of_location?: number
  enable_customer_assign_driver?: boolean
  maximum_mutiple_booking?: number
  minimal_drivers_setting?: number
  check_pod_by_default?: boolean
  can_toggle_pod?: boolean
  enable_batch_multiple?: boolean
  enable_smart_load?: boolean
}

export interface Account {
  company_id: number
  name: string
  email: string
  phone: string
  description: string
  photo_url: null
  logo_url: null
}

export interface IAuth {
  login: Login
  isLogged: boolean
  customerFtlConfig?: CustomerFtlConfig
  errorCurrentPassword: string
  currentCredits: number
}

export const initAuth: IAuth = {
  login: { accounts: { id: 0, name: '', phone: '', address_detail: '' } },
  isLogged: false,
  errorCurrentPassword: '',
  currentCredits: 0,
}

export interface IDecodeToken {
  customer_id: number
  company_id: number
  iss: string
  jwt_platform?: string
  customer_name?: string
  customer_email?: string
  customer_phone?: string
  customer_avatar?: string
  owner_id?: number
  owner_type: string
  sub?: string
  scp?: string
  aud?: string
  iat: number
  exp: number
  jti: string
}
